export default __webpack_public_path__ + "static/media/docker.8ad0f8cf.png";